export const baseUrl = () => {
  console.log(process.env.NODE_ENV);

  if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    return "http://127.0.0.1:8000/";
  } else {
    return "https://db.acmeg.org.af/";
  }
};

export const BASE_URL = baseUrl();
